import { Component } from '@angular/core';
import { NavController, NavParams, 
		 ToastController, AlertController, ActionSheetController, 
		 LoadingController, ModalController } from 'ionic-angular';

import { BusinessProductPaymentManagerHandler } from '../../providers/business-product-payment-handler';
import { ProductPaymentCheckoutHandler } from '../../providers/product-payment-checkout-handler';
import { ConsumerMoneyProvider } from '../../providers/consumer-money-handler';
import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';
import { ConsumerMoneyOrderHandlerProvider } from '../../providers/consumer-money-order-handler';

import { Globals } from '../../providers/globals';

import { ConsumerAddMoneyPage } from '../../pages/consumer-add-money/consumer-add-money';
import { BusinessProductSearchPage } from '../business-product-search/business-product-search';
import { BusinessProductCategoryPage } from '../business-product-category/business-product-category';

@Component({
  selector: 'page-consumer-product-payment-manager',
  templateUrl: 'consumer-product-payment-manager.html',
})
export class ConsumerProductPaymentManagerPage {
	groups: any = [{
		index: 0,
		products: []
	}]

	categories: any;
	selectedCategories: any;

	selectedProducts: any = [];
	consumer: any;
	business: any;

	hasProducts: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;
	loadingMsg: any = "Loading...";
	userIsLoading: boolean = false

	params: any = {
		page: 1,
		size: 20,
		cb: null
	}

	constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public consumerMoneyProvider: ConsumerMoneyProvider,
		public productManagerHandler: BusinessProductPaymentManagerHandler,
		public consumerBusinessHandler: ConsumerBusinessHandlerProvider,
		public consumerMoneyOrderHandler: ConsumerMoneyOrderHandlerProvider,
		public checkoutHandler: ProductPaymentCheckoutHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public actionSheetCtrl: ActionSheetController,
		public modalCtrl: ModalController,
		public globals: Globals,
		public toastCtrl: ToastController,
	) {
		this.filePath = this.globals.fileUrl;

		this.business = this.navParams.get("business");
	}

	ionViewDidLoad() {	
	}

	presentSearchModal(group) {
		this.checkoutHandler.activeGroupIndex = group.index;

		let searchModal = this.modalCtrl.create(BusinessProductSearchPage, {});

		searchModal.onDidDismiss(group => {
			this.checkoutHandler.activeGroupIndex = null;

			this.checkoutHandler.order.total = 0;

			for(var group of this.checkoutHandler.order.groups){
				this.checkoutHandler.order.total += group.total ? group.total : 0;
			}
		});

		searchModal.present();
	}

	selectProduct($e, product) {
		product.Count = product.Count ? product.Count + 1 : 1;

		this.checkoutHandler.order.total += product.Price;
	}

	addOrder(){
		var groupObj = {
			index: this.checkoutHandler.order.groups.length,
			products: []
		}

		this.checkoutHandler.order.groups.push(groupObj)
	}

	recharge(){
		this.navCtrl.push(ConsumerAddMoneyPage, {
		  business: this.consumerBusinessHandler.business
		});		
	}

	notEnoughBalanca(){
		return this.checkoutHandler.order.total>this.consumerBusinessHandler.business.Balance
	}

	tryPayorder(){
	   let actionSheet = this.actionSheetCtrl.create({
	     title: '$ ' + this.checkoutHandler.order.total + ' will be debited from your balance. Are you sure?',
	     buttons: [
	       {
	         text: 'Yes',
	         handler: () => {
	           	console.log('Archive clicked');

	           	this.payOrder()

	           	actionSheet.dismiss();

	           	return false;
	         }
	       },
	       {
	         text: 'No',
	         handler: () => {
	           actionSheet.dismiss();

	           return false;
	         }
	       }
	     ]
	   });

	   actionSheet.present();			
	}

	payOrder(){
		var loader = this.loadingCtrl.create({
			content: "Creating order...",
			showBackdrop: true
		});

		loader.present();  

		this.consumerMoneyProvider.createOrder({		    
	        BusinessId: this.business.Id,
	        Amount: this.checkoutHandler.order.total,
		    Products: this.checkoutHandler.order.products,
		    GroupJson: JSON.stringify(this.checkoutHandler.order.groups)
		})
		.then((data: any)=>{
			loader.dismiss();

			if(data.Message){
				let toast = this.toastCtrl.create({
					message: 'There was an error: ' + data.Message,
					duration: 5000,
					position: 'bottom'
				});

				toast.present();  
			}else{
				let toast = this.toastCtrl.create({
					message: 'Order created successfully!',
					duration: 5000,
					position: 'middle',
					showCloseButton: true,
					closeButtonText: 'Ok'
				});

				this.checkoutHandler.clearOrder();
				this.consumerBusinessHandler.refreshBusiness();
				this.consumerMoneyOrderHandler.getOrdersForAllBusinesses({
					page: 1, 
					size: 20, 
				});
				this.consumerMoneyOrderHandler.getOrders({
					businessId: this.business.Id, 
					page: 1, 
					size: 20, 
				});
						
				toast.onDidDismiss(() => {
					this.navCtrl.pop();
				});

				toast.present();  
			}
		})
		.catch((err)=>{
			loader.dismiss();

			let toast = this.toastCtrl.create({
				message: 'There was an error: ' + err,
				duration: 3000,
				position: 'bottom'
			});

		  	toast.present();  
		});
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-product-payment-manager/consumer-product-payment-manager.ts